import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { SegmentInput } from 'Components/contracts/segment'
import {
  setContract,
  setNoOfLeads,
  setSegmentName,
  setSegmentsForContract,
  setSegmentsLeadsTotal,
  selectNewAnnualSegment,
} from './NewAnnualSegmentSlice'
import { useGetSegmentsForContractQuery } from 'Services/segments/segments'
import { Loading } from 'Utils/loading'
import { ContractSource } from 'Types/index'

interface DuplicateTimeBasedProps {
  control: any
  setFormError: any
  clearFormErrors: any
  showSidebar: boolean
  inquiryContract?: any
  segmentData?: any
}

export const DuplicateTimeBased = ({
  control,
  inquiryContract,
  segmentData,
  setFormError,
  clearFormErrors,
}: DuplicateTimeBasedProps) => {
  const dispatch = useDispatch()
  const { ipedId } = useParams()
  const {
    contract,
    segmentsRelatedToContract,
    segmentsLeadsTotal,
    noOfLeads,
    segmentName,
  } = useSelector(selectNewAnnualSegment)

  const { data: segments, isLoading: isLoadingSegments } =
    useGetSegmentsForContractQuery(
      {
        ipedId,
        contractId: contract?.id,
      },
      { skip: contract?.id == undefined }
    )

  let segmentNames = []
  let segmentLeadsTotal = 0
  const remainingLeads = contract?.lead_cap - segmentsLeadsTotal

  const setSelectedContract = (contract: any) => {
    dispatch(setContract(contract))
  }

  const handleNoOfLeadsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setNoOfLeads(String(e.target.value)))
  }

  const handleSegmentNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setSegmentName(e.target.value))
  }

  useEffect(() => {
    if (inquiryContract && segmentData) {
      setSelectedContract(inquiryContract)
      dispatch(setSegmentName(segmentData['name']))
      dispatch(setNoOfLeads(segmentData['lead_total'].toString()))
    }
  }, [inquiryContract, segmentData])

  /** Calculate the related segments and the total leads for a contract */
  useEffect(() => {
    if (segments && contract) {
      segments?.forEach((segment: any) => {
        segmentNames.push(segment.name)
        segmentLeadsTotal += segment.is_active
          ? segment.lead_total
          : segment.leads_delivered ?? 0
      })
      clearFormErrors('root.relatedContracts')
      dispatch(setSegmentsForContract(segmentNames))
      dispatch(setSegmentsLeadsTotal(segmentLeadsTotal))
    }
  }, [segments, contract])

  /** Check and add duplicate segment name error */
  useEffect(() => {
    if (segmentsRelatedToContract.includes(segmentName)) {
      setFormError(
        'root.segmentName',
        {
          type: 'manual',
          message: 'This name is already in use on the same Contract',
        },

        { shouldFocus: true }
      )
    } else {
      clearFormErrors('root.segmentName')
    }
  }, [segmentsRelatedToContract, segmentName])

  if (isLoadingSegments) return <Loading />

  return (
    <SegmentInput
      setSelectedContract={setSelectedContract}
      handleNoOfLeadsChange={handleNoOfLeadsChange}
      handleSegmentNameChange={handleSegmentNameChange}
      chosenContract={contract}
      segmentName={segmentName}
      noOfLeads={noOfLeads}
      remainingLeads={remainingLeads}
      control={control}
      source={ContractSource.inquiries}
    />
  )
}
